import { IDM_URL } from "@/constants";
import { post, get } from "@/utils/requestKong";
export function getUserInfo(token: string) {
  return post({
    url: "/getUserInfo",
    config: {
      headers: {
        loginType: "idm",
        token: token,
        appId: "asleads",
      },
    },
    baseURL: IDM_URL,
  });
}
